import Crud from '../components/AbsenceRequest/Crud'
import Add from '../components/AbsenceRequest/Add'
import Approve from '../components/AbsenceRequest/Approve'

let routes = {
    path: '/absenceRequests',
    component: resolve => require(['../components/layout/App'], resolve),
    children: [
        {
            path: '/absenceRequests',
            name: 'Listagem de ausencia',
            component: Crud
        },
        {
            path: '/absenceRequest/:id?',
            name: 'Solicitações de ausencia',
            component: Add
        },
        {
            path: '/absenceRequests/approve',
            name: 'Aprovacao de Solicitacao de ausencia',
            component: Approve
        }
    ]
}

export default routes


// WEBPACK FOOTER //
// ./src/router/absenceRequest.js